import { v4 as uuidv4 } from 'uuid';

import { ROLE_RECEIVER_TYPE } from '../constants';
export const formatSelectedRolesForTable = (policyRoles, locationRoles) => {
  if (!policyRoles || !locationRoles) return [];
  const displayReceivers = [];
  policyRoles.forEach(roleId => {
    const locationRole = locationRoles.find(r => r.id === roleId);
    if (locationRole) displayReceivers.push(locationRole.name);
  });
  return displayReceivers;
};

export const getPolicyRolesFromReceivers = policyReceivers =>
  policyReceivers
    ?.filter(receiver => receiver.receiver_type === ROLE_RECEIVER_TYPE)
    ?.map(r => r.receiver_id) || [];

export const getPolicyRoleSplitsFromReceivers = policyReceivers =>
  policyReceivers
    ?.filter(receiver => receiver.receiver_type === ROLE_RECEIVER_TYPE)
    ?.map(r => ({
      rowId: uuidv4(),
      roleId: r.receiver_id,
      id: r.id,
      percentage: r.percentage?.toString() || '0',
    })) || [];

export const getReceiverIdFromRoleId = (policyReceivers, roleId) => {
  if (!policyReceivers || !roleId) return null;
  const role = policyReceivers.find(
    r => r.receiver_id === roleId && r.receiver_type === ROLE_RECEIVER_TYPE
  );
  return role?.id;
};

export const formatRolesWithPercentagesForTable = (
  policyReceivers,
  locationRoles
) => {
  if (!policyReceivers || !locationRoles) return [];

  const roleSplits = getPolicyRoleSplitsFromReceivers(policyReceivers);

  return roleSplits
    .map(split => {
      const locationRole = locationRoles.find(r => r.id === split.roleId);
      return {
        id: split.roleId,
        name: locationRole?.name,
        percentage: split.percentage,
      };
    })
    .filter(role => !!role.name);
};
